<template>
  <div :class="bem.b()">
    <a-form ref="form">
      <ll-form-item v-bind="validateInfos.url">
        <api-url
          v-model:value="httpModel"
          :class="bem.m('header')"
          @change="handleChange"
        />
      </ll-form-item>

      <params-table
        v-show="activeKey === 'params'"
        :columns="paramsTableColumns"
        :data-source="httpModel.requestParams"
      />
      <params-table
        v-show="activeKey === 'headers'"
        :columns="headersTableColumns"
        :data-source="httpModel.headerParams"
      />
      <body-component v-show="activeKey === 'body'" v-model:value="httpModel" />
    </a-form>
  </div>
</template>

<script setup lang="ts">
import { computed, provide, ref, watch } from 'vue'

import { Form } from 'ant-design-vue'

import {
  apiComponentEmits,
  apiComponentProps,
  headersTableColumns,
  IMethod,
  paramsTableColumns,
  requestList,
} from './config'

import { createNamespace } from '@ll-plus/utils'
// Components
import ApiUrl from './components/api-url.vue'

import paramsTable from './components/params-table.vue'

import BodyComponent from './components/body-component.vue'

defineOptions({ name: 'LlApiComponent' })

const props = defineProps(apiComponentProps)

const emits = defineEmits(apiComponentEmits)

const bem = createNamespace('api-component')

const useForm = Form.useForm

const formItemContext = Form.useInjectFormItemContext()

const form = ref()

const activeKey = ref('params')

const computedRules = computed(() => (props.isValid ? props.rules : {}))

provide('disabled', props.disabled)

const httpModel = ref(props.value)

const computedRequestList = computed(() => {
  if (httpModel.value.method === 'GET') {
    return requestList.filter((item) => item.key !== 'body')
  }
  return requestList
})

const { resetFields, validate, validateInfos } = useForm(
  httpModel,
  computedRules.value
  // {
  //   onValidate: (...args) => {
  //     console.log('onValidate', args)
  //   }
  // }
)

const handleChange = (params: { url: string; method: IMethod }) => {
  httpModel.value.method = params.method
  httpModel.value.url = params.url
  formItemContext.onFieldChange()
  setValue()
}

const setValue = () => {
  emits('change', httpModel.value)
  emits('update:value', httpModel.value)
}

watch(
  () => props.value,
  (val) => {
    httpModel.value = val
  },
  {
    deep: true,
  }
)

watch(
  () => httpModel,
  () => {
    setValue()
  },
  {
    deep: true,
  }
)

defineExpose({
  validate,
  resetFields,
})
</script>
